(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = c => { try { return new Intl.NumberFormat((GY.locale||'en') + '-AU', { style: 'currency', currency: GY.currency || 'AUD', currencyDisplay: 'narrowSymbol' }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' ' + (GY.currency||''); } };
  const drawer = $('#CartDrawer');
  const open = () => { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
  const close = () => { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  async function render(cart) {
    cart = cart || await fetch(GY.routes.cart + '.js').then(r => r.json());
    $$('[data-cart-count]').forEach(e => { e.textContent = cart.item_count; e.hidden = !cart.item_count; });
    const lines = $('[data-cart-lines]');
    lines.innerHTML = cart.items.length ? cart.items.map((i, n) => `
      <div class="line">
        <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''}" alt="" loading="lazy">
        <div><div class="line__t">${esc(i.product_title)}</div>${i.variant_title ? `<div class="line__v">${esc(i.variant_title)}</div>` : ''}
          ${i.selling_plan_allocation ? '' : ''}<div class="qty" style="margin-top:8px"><button data-line="${n + 1}" data-q="${i.quantity - 1}" aria-label="Decrease">−</button><input value="${i.quantity}" readonly aria-label="Quantity"><button data-line="${n + 1}" data-q="${i.quantity + 1}" aria-label="Increase">+</button></div>
          <button class="line__rm" data-line="${n + 1}" data-q="0">Remove</button></div>
        <div><strong>${money(i.final_line_price)}</strong></div>
      </div>`).join('') : `<div class="empty"><p>Your bag is empty.</p><a class="btn" href="/products/got-you-drink-test-nail-stickers">Shop the stickers</a></div>`;
    $('[data-cart-foot]').hidden = !cart.items.length;
    $('[data-cart-total]').textContent = money(cart.total_price);
    const t = GY.freeShip, left = Math.max(0, t - cart.total_price);
    const has20 = cart.items.some(i => /(^|\D)(20|30)\s*sticker/i.test(i.variant_title || ''));
    const track = $('.ship-bar__track');
    if (has20 || (t && !left)) { track.hidden = false; $('[data-ship-fill]').style.width = '100%'; $('[data-ship-msg]').innerHTML = `<strong>You've unlocked free shipping.</strong>`; }
    else if (t) { track.hidden = false; $('[data-ship-fill]').style.width = Math.min(100, cart.total_price / t * 100) + '%'; $('[data-ship-msg]').innerHTML = `You're <strong>${money(left)}</strong> away from free shipping, or go for a 20-pack and it ships free.`; }
    else { track.hidden = true; $('[data-ship-msg]').innerHTML = `<strong>Free shipping on 20-packs</strong>, wherever you are.`; }
  }
  async function change(line, quantity) {
    const cart = await fetch(GY.routes.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) }).then(r => r.json());
    render(cart);
  }
  async function add(id, quantity = 1, btn) {
    if (btn) { btn.disabled = true; btn.dataset.l = btn.innerHTML; btn.innerHTML = 'Adding…'; }
    const r = await fetch(GY.routes.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] }) });
    if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.l; }
    if (!r.ok) { const e = await r.json().catch(() => ({})); alert(e.description || 'Could not add to bag'); return; }
    await render(); open();
  }
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-open-cart],[data-close-cart],[data-line],[data-quick-add],[data-menu-toggle]');
    if (!t) return;
    if (t.matches('[data-open-cart]')) { e.preventDefault(); render(); open(); }
    else if (t.matches('[data-close-cart]')) close();
    else if (t.matches('[data-line]')) change(+t.dataset.line, Math.max(0, +t.dataset.q));
    else if (t.matches('[data-quick-add]')) add(+t.dataset.quickAdd, 1, t);
    else if (t.matches('[data-menu-toggle]')) { const m = $('#MobileNav'); m.classList.toggle('open'); t.setAttribute('aria-expanded', m.classList.contains('open')); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  // Product form
  $$('[data-product]').forEach(root => {
    const form = $('form[data-product-form]', root), idInput = $('[name=id]', form);
    const variants = JSON.parse($('[data-variants]', root).textContent);
    const sticky = $('[data-sticky-atc]'), stickySel = sticky && $('select', sticky);
    const update = id => {
      const v = variants.find(x => x.id == id); if (!v) return;
      idInput.value = v.id;
      $$('[data-price]', root).forEach(e => e.textContent = money(v.price));
      const cmp = $('[data-compare]', root); if (cmp) { cmp.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      const btn = $('[data-atc]', root); btn.disabled = !v.available; $('[data-atc-label]', root).textContent = v.available ? btn.dataset.label : 'Sold out';
      $$('[data-sticky-price]').forEach(e => e.textContent = money(v.price));
      if (stickySel) stickySel.value = v.id;
      const r = $(`input[name=pack][value="${v.id}"]`, root); if (r) r.checked = true;
      if (v.featured_media) { const th = $(`[data-media-id="${v.featured_media.id}"]`, root); th && th.click(); }
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    };
    $$('input[name=pack]', root).forEach(r => r.addEventListener('change', () => update(r.value)));
    stickySel && stickySel.addEventListener('change', () => update(stickySel.value));
    const qty = $('[name=quantity]', form);
    $$('[data-qty]', root).forEach(b => b.addEventListener('click', () => { qty.value = Math.max(1, (+qty.value || 1) + +b.dataset.qty); }));
    form.addEventListener('submit', e => { e.preventDefault(); add(+idInput.value, +qty.value || 1, $('[data-atc]', root)); });
    sticky && $('button', sticky).addEventListener('click', () => add(+idInput.value, +qty.value || 1, $('button', sticky)));
    // gallery
    $$('[data-thumb]', root).forEach(b => b.addEventListener('click', () => {
      const m = $('.gallery__main img', root); m.src = b.dataset.src; m.srcset = ''; m.alt = b.dataset.alt || '';
      $$('[data-thumb]', root).forEach(x => x.setAttribute('aria-current', x === b));
    }));
    // sticky atc visibility
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0)).observe($('[data-atc]', root));
    }
  });
  render().catch(() => {});
})();
